import { useMemo } from 'react';
import { useParams } from 'react-router';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TAB_INFO } from '~/pages/DomainNames/@constants';
import { DomainNamesTabGroupEnum } from '~/pages/DomainNames/@types';
import { DomainNamesRouteEnum, RootRouteEnum } from '~/router/@types';

export const useTab = () => {
  const navigate = useNavigate();

  const { tab = DomainNamesRouteEnum.Flagged } = useParams<{
    tab: DomainNamesRouteEnum;
  }>();
  const [searchParams] = useSearchParams();

  const tabGroup = useMemo(
    () =>
      Object.values(TAB_INFO).find((tabItem) => {
        if ('path' in tabItem) return tabItem.path === tab;
        return tabItem.children.some(({ path }) => path === tab);
      })?.key || DomainNamesTabGroupEnum.Flagged,
    [tab]
  );

  const handleChange = (tab: DomainNamesRouteEnum) => {
    const brandId = searchParams.get('brand_id');
    const newSearchParams = new URLSearchParams();

    if (brandId) {
      newSearchParams.set('brand_id', brandId);
    }

    navigate(`/${RootRouteEnum.DomainNames}/${tab}?${newSearchParams.toString()}`);
  };

  return {
    currentTabGroup: tabGroup,
    currentTab: tab,
    onChange: handleChange,
  };
};
